<template>
    <BaseForm :panels="panels" :action="createAction" :formClass="formClass" :errorMessage="errorMessage" :method="method" :baseMethod="baseMethod" :moduleName="moduleName" :list-link="listLink" :model="model"></BaseForm>
</template>

<script>
import BaseForm from '../../core/BaseForm'
export default {
  name: 'CustomEditModule',
  components: {BaseForm},
  props: ['panels', 'apiUrl', 'formClass', 'moduleName', 'listLink'],
  data () {
    return {
      errorMessage: [],
      method: 'PUT',
      baseMethod: 'POST',
      createAction: '',
      model: {}
    }
  },
  created: function () {
    this.$emit('updateTitle', this.moduleName + ' ' + this.$translate.t('Edit'))
    this.createAction = this.apiUrl + '/update/' + this.$route.params.id

    let self = this
    this.$http
      .get(this.apiUrl + `/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.model = res.data.data
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/custom/CustomEditModule.vue